module.exports = __webpack_public_path__ + "static/media/chain-logo.cd202ca8.png";